<template>
  <span
    class="tw-box-content tw-inline-flex tw-aspect-[1/1] tw-h-[32px] tw-w-[32px] tw-shrink-0 tw-items-center tw-justify-center tw-rounded-[50px] tw-border tw-border-gray-200 tw-bg-white"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path :d="path" fill="black" />
    </svg>
  </span>
</template>

<script>
const CARET_LEFT =
  'M6.96896 11.4694L14.469 3.96938C14.5386 3.8997 14.6214 3.84443 14.7124 3.80672C14.8035 3.769 14.901 3.74959 14.9996 3.74959C15.0981 3.74959 15.1957 3.769 15.2868 3.80672C15.3778 3.84443 15.4605 3.8997 15.5302 3.96938C15.5999 4.03907 15.6552 4.12179 15.6929 4.21284C15.7306 4.30388 15.75 4.40146 15.75 4.50001C15.75 4.59856 15.7306 4.69614 15.6929 4.78718C15.6552 4.87823 15.5999 4.96095 15.5302 5.03063L8.5599 12L15.5302 18.9694C15.6709 19.1101 15.75 19.301 15.75 19.5C15.75 19.699 15.6709 19.8899 15.5302 20.0306C15.3895 20.1714 15.1986 20.2504 14.9996 20.2504C14.8006 20.2504 14.6097 20.1714 14.469 20.0306L6.96896 12.5306C6.89923 12.461 6.84391 12.3783 6.80616 12.2872C6.76842 12.1962 6.74899 12.0986 6.74899 12C6.74899 11.9014 6.76842 11.8039 6.80616 11.7128C6.84391 11.6218 6.89923 11.539 6.96896 11.4694Z';

const CARET_RIGHT =
  'M17.031 12.5306L9.53104 20.0306C9.46136 20.1003 9.37863 20.1556 9.28759 20.1933C9.19654 20.231 9.09896 20.2504 9.00042 20.2504C8.90187 20.2504 8.80429 20.231 8.71324 20.1933C8.6222 20.1556 8.53947 20.1003 8.46979 20.0306C8.40011 19.9609 8.34483 19.8782 8.30712 19.7872C8.26941 19.6961 8.25 19.5985 8.25 19.5C8.25 19.4014 8.26941 19.3039 8.30712 19.2128C8.34483 19.1218 8.40011 19.039 8.46979 18.9694L15.4401 12L8.46979 5.03061C8.32906 4.88988 8.25 4.69901 8.25 4.49999C8.25 4.30097 8.32906 4.1101 8.46979 3.96936C8.61052 3.82863 8.80139 3.74957 9.00042 3.74957C9.19944 3.74957 9.39031 3.82863 9.53104 3.96936L17.031 11.4694C17.1008 11.539 17.1561 11.6217 17.1938 11.7128C17.2316 11.8038 17.251 11.9014 17.251 12C17.251 12.0986 17.2316 12.1961 17.1938 12.2872C17.1561 12.3782 17.1008 12.461 17.031 12.5306Z';

export default {
  name: 'CaretCircle',
  props: {
    direction: {
      type: String,
      default: 'right',
      validator: (value) => ['left', 'right'].includes(value),
    },
  },
  computed: {
    path() {
      return this.direction === 'left' ? CARET_LEFT : CARET_RIGHT;
    },
  },
};
</script>
